/**
 * Updates the browser tab favicon at runtime.
 *
 * The site logo is admin-configurable (uploaded via Site Settings → Logo),
 * not a static build-time asset, so it can't simply live as a fixed
 * <link rel="icon" href="..."> in public/index.html. Instead we patch the
 * existing icon link's href once the logo URL is known.
 */
export function setFavicon(url) {
  if (!url) return;

  // Reuse the icon link declared in index.html if present, otherwise create one.
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;

  // Also cover Apple touch icon (home-screen / bookmark icon on iOS/macOS).
  let touchLink = document.querySelector("link[rel='apple-touch-icon']");
  if (!touchLink) {
    touchLink = document.createElement("link");
    touchLink.rel = "apple-touch-icon";
    document.head.appendChild(touchLink);
  }
  touchLink.href = url;
}